<template>
  <span :style="block ? 'width: 100%' : ''">
    <slot :select-files="selectFiles">
      <v-btn :outlined="outline"
             :color="color"
             :text="flat"
             :depressed="depressed"
             :block="block"
             :dark="dark"
             :icon="!label"
             :disabled="disabled"
             :large="large"
             :class="lower ? 'reg-btn-lower' : ''"
             @click="selectFiles">
        <v-icon v-if="icon" :class="label ? 'mr-2' : ''">
          {{ icon }}
        </v-icon>
        <span v-if="label">
          {{ label }}
        </span>
      </v-btn>
    </slot>
    <input ref="inputFile"
           :multiple="multiple"
           :accept="accept"
           :required="required"
           :capture="forcePhotoCapture"
           type="file"
           class="display-none"
           @change="onFilesSelected">
  </span>
</template>

<script>
import _ from 'lodash'
export default {
  name: 'UploadButton',
  props: {
    imageUpload: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: true
    },
    required: {
      type: Boolean,
      default: false
    },
    allowedExtensions: {
      type: Array,
      default: () => []
    },
    outline: {
      type: Boolean,
      default: false
    },
    flat: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    lower: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    depressed: {
      type: Boolean,
      default: false
    },
    block: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'primary'
    },
    icon: {
      type: String,
      default: 'attach_file'
    },
    label: {
      type: String,
      default: ''
    },
    forcePhotoCapture: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    accept() {
      if (!this.allowedExtensions.length) {
        return this.imageUpload ? 'image/*' : ''
      }

      return '.' + _.join(this.allowedExtensions, ', .')
    }
  },
  methods: {
    selectFiles() {
      this.$refs.inputFile.value = ''
      this.$emit('select-files')
      this.$refs.inputFile.click()
    },
    onFilesSelected(e) {
      // validate extensions
      if (this.allowedExtensions.length) {
        const files = e.target.files
        for (let i = 0; i < files.length; i++) {
          const file = files[i]
          const ext = file.name.split('.').pop()
          if (!this.allowedExtensions.includes(ext)) {
            this.$toasted.error(`Arquivo inválido. Somente as extensões ${_.join(this.allowedExtensions.map(ext => String(ext).toUpperCase()), ', ')} são permitidas.`)
            return
          }
        }
      }
      this.$emit('files-selected', e.target)
    }
  }
}
</script>
